import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import {
  LoadingProgressComponent,
  LoadingStep,
} from '../../../../../common/components/loading-progress/loading-progress';
import { THEME_COLOR } from '../../services/lesson-plan.models';

@Component({
  selector: 'app-step-loading',
  standalone: true,
  imports: [LoadingProgressComponent],
  template: `
    <app-loading-progress
      [title]="title"
      [subtitle]="subtitle"
      [tipText]="tipText"
      [themeColor]="themeColor"
      [steps]="steps"
    ></app-loading-progress>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepLoadingComponent {
  @ViewChild(LoadingProgressComponent) loadingComponent?: LoadingProgressComponent;

  protected readonly themeColor = THEME_COLOR;
  protected readonly title = 'Finding the best objectives';
  protected readonly subtitle = 'This usually takes about a minute. Hang tight!';
  protected readonly tipText =
    "We're matching your lesson to educational standards for the best alignment.";

  protected readonly steps: LoadingStep[] = [
    { id: 1, label: 'Preparing your lesson...' },
    { id: 2, label: 'Analyzing topic and grade level...' },
    { id: 3, label: 'Fetching educational standards...' },
    { id: 4, label: 'Matching relevant objectives...' },
    { id: 5, label: 'Ranking by alignment...' },
    { id: 6, label: 'Finalizing recommendations...' },
  ];

  /**
   * Complete the progress (called externally when objectives are ready).
   */
  complete(): void {
    this.loadingComponent?.complete();
  }
}
